var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MessageType } from "../../models/message-type";
import { ViewType } from "../../models/view-type";
import { Avatar } from "../avatar";
import { Base } from "../base";
var ChatAvatar = /** @class */ (function (_super) {
    __extends(ChatAvatar, _super);
    function ChatAvatar(type, source, viewType, width, height, onClickAction, backgroundColor) {
        if (backgroundColor === void 0) { backgroundColor = null; }
        var _this = _super.call(this) || this;
        _this.setFullSizeWindow = function (viewType) {
            if (viewType === ViewType.DesktopLarge) {
                _this.self.style.width = '4%';
                _this.self.style.minWidth = 'max-content';
            }
            else {
                _this.self.style.width = '';
                _this.self.style.minWidth = '';
            }
            _this.self.style.paddingLeft = '3px';
            _this.self.style.paddingRight = '3px';
        };
        _this._avatar = new Avatar(source, width, height, onClickAction, backgroundColor);
        var chatAvatar = document.createElement('div');
        chatAvatar.style.marginTop = '11px';
        chatAvatar.style.float = type === MessageType.Assistant ? 'left' : 'right';
        chatAvatar.appendChild(_this._avatar.self);
        _this.self = chatAvatar;
        if (viewType === ViewType.DesktopSmall) {
            _this.setSmallSizeWindow();
        }
        else {
            _this.setFullSizeWindow(viewType);
        }
        return _this;
    }
    ChatAvatar.prototype.setSmallSizeWindow = function () {
        this.self.style.width = '11%';
        this.self.style.minWidth = '';
        this.self.style.paddingLeft = '';
        this.self.style.paddingRight = '';
    };
    return ChatAvatar;
}(Base));
export { ChatAvatar };
